<div *ngIf='entryImage.imgurl' class="outer">
    <div class="modal-dialog" [hidden]='isHidden' (click)='toggleDisplay()'>
        <div class='modal-content'>
            <img src="{{entryImage.tnImgUrl}}"/>
        </div>
    </div>

    <div class="card-body">
        <h5 *ngIf='undersize' class="warning">Warning: Undersized Image Entry</h5>
        <h5 class="card-title">{{entryImage.title}}</h5>
        <p *ngIf='showDescription' class="card-text">{{entryImage.description}}</p>
   </div>

    <span *ngIf='entryImage.unframedWidth && entryImage.unframedHeight' class="badge badge-pill badge-light">Dimensions: {{entryImage.unframedWidth}}" x {{entryImage.unframedHeight}}"</span>
    <span *ngIf='entryImage.framedWidth && entryImage.framedHeight' class="badge badge-pill badge-light">Framed: {{entryImage.framedWidth}}" x {{entryImage.framedHeight}}"</span>
    <img [hidden]='loading' class="img-fluid" src="{{entryImage.tnImgUrl}}" (load)='onLoad()' (click)='toggleDisplay()'/>
</div>